export default __webpack_public_path__ + "3581424833559401f1aaec0c3f3b06cb.svg";